let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("45Stc")).then(() => parcelRequire('27Ap3'));